import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledErrorX: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_error-x"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="error-x icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 33 32"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M22.2071 10.2929C22.5976 10.6834 22.5976 11.3166 22.2071 11.7071L17.9142 16L22.2071 20.2929C22.5976 20.6834 22.5976 21.3166 22.2071 21.7071C21.8166 22.0976 21.1834 22.0976 20.7929 21.7071L16.5 17.4142L12.2071 21.7071C11.8166 22.0976 11.1834 22.0976 10.7929 21.7071C10.4024 21.3166 10.4024 20.6834 10.7929 20.2929L15.0858 16L10.7929 11.7071C10.4024 11.3166 10.4024 10.6834 10.7929 10.2929C11.1834 9.90237 11.8166 9.90237 12.2071 10.2929L16.5 14.5858L20.7929 10.2929C21.1834 9.90237 21.8166 9.90237 22.2071 10.2929ZM16.5 2C8.76801 2 2.5 8.26801 2.5 16C2.5 23.732 8.76801 30 16.5 30C24.232 30 30.5 23.732 30.5 16C30.5 8.26801 24.232 2 16.5 2ZM4.5 16C4.5 9.37258 9.87258 4 16.5 4C23.1274 4 28.5 9.37258 28.5 16C28.5 22.6274 23.1274 28 16.5 28C9.87258 28 4.5 22.6274 4.5 16Z" />
      </svg>
    </span>
  );
};

export { FilledErrorX };
